import React from "react";

export const BodyScrollContext = React.createContext<{ bodyProgress: React.RefObject<number> | null }>({ bodyProgress: null });
export default BodyScrollContext;

export const BodyScrollContextWrapper: React.FC<React.PropsWithChildren> = (props) => {
    const bodyProgress = React.useRef(0);

    React.useEffect(() => {
        let animationCallback: ReturnType<Window["requestAnimationFrame"]> | undefined;

        function scrollCallback() {
            const updatedValued = Math.max(
                0,
                Math.min(1, (bodyProgress.current = window.scrollY / (document.documentElement.scrollHeight - (window.visualViewport?.height ?? 0))))
            );
            window.cancelAnimationFrame(animationCallback!);
            animationCallback = window.requestAnimationFrame(() => {
                document.body.style.setProperty("--body-scroll", updatedValued.toString());
            });
        }

        scrollCallback();

        document.addEventListener("scroll", scrollCallback);
        return () => document.removeEventListener("scroll", scrollCallback);
    }, []);

    return <BodyScrollContext.Provider value={{ bodyProgress: bodyProgress }}>{props.children}</BodyScrollContext.Provider>;
};
